export const LOAD_TABS = 'LOAD_TABS';
export const LOAD_BILLING_DETAILS = 'LOAD_BILLING_DETAILS';
export const LOAD_TEAM_PERMISSIONS = 'LOAD_TEAM_PERMISSIONS';
export const LOAD_CURRENT_PLAN_DETAILS = 'LOAD_CURRENT_PLAN_DETAILS';
export const LOAD_TEAM_DETAILS = 'LOAD_TEAM_DETAILS';
